import React, { useEffect, useState } from "react";
import API_BASE_URL from "../../../config";
import Sidebar from "./Sidebar";
import axios from "axios";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../Styles/Admin/assessment/Quizzes.css";

const answerColors = {
  "Strongly Disagree": "#e53935",
  "Disagree": "#e53935",
  "Neutral": "#e53935",
  "Agree": "#43a047",
  "Strongly Agree": "#43a047"
};

const shareThoughtsQuestions = [
  "What makes you feel valued and supported in our workplace culture?",
  "What one thing would you like to see changed or improved in our workplace culture, and why?"
];

const ViewDetails = () => {
  const [answers, setAnswers] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();

  // Get employee_email from query string
  const params = new URLSearchParams(location.search);
  const employee_email = params.get("employee_email");

  useEffect(() => {
    fetchDetails();
    // eslint-disable-next-line
  }, [employee_email]);

  const fetchDetails = async () => {
    try {
      const res = await axios.get(`${API_BASE_URL}/api/assessment-answers?employee_email=${encodeURIComponent(employee_email)}`);
      setAnswers(res.data.answers || []);
    } catch (err) {
      setAnswers([]);
    }
  };

  // Group answers by section
  const grouped = answers.reduce((acc, ans) => {
    acc[ans.section] = acc[ans.section] || [];
    acc[ans.section].push(ans);
    return acc;
  }, {});

  // Flatten all answers and sort by question_id for global numbering
  const allAnswers = Object.values(grouped).flat();
  allAnswers.sort((a, b) => a.question_id - b.question_id);

  // Map question_id to global index
  const questionIndexMap = {};
  allAnswers.forEach((ans, idx) => {
    questionIndexMap[ans.question_id] = idx + 1;
  });

  return (
    <div className="quizzes-container">
      <Sidebar />
      <div className="quizzes-content">
        <div className="quizzes-card" style={{ maxWidth: 700, margin: "0 auto" }}>
          <h2 className="quizzes-title">View Details</h2>
          {answers.length === 0 ? (
            <div style={{ textAlign: "center", color: "#aaa", padding: 24 }}>
              No answers found for this employee.
            </div>
          ) : (
            Object.entries(grouped).map(([section, sectionAnswers], sidx) => (
              <div key={section} style={{ marginBottom: 32 }}>
                <h3 style={{ marginBottom: 12, color: "#183b8c" }}>{section}</h3>
                {sectionAnswers.map((ans, idx) => {
                  // Identify Share Your Thoughts questions by section or question text
                  const isShareThoughts =
                    section === "Share Your Thoughts" ||
                    shareThoughtsQuestions.some(qtxt =>
                      ans.question?.trim().toLowerCase() === qtxt.trim().toLowerCase()
                    );
                  return (
                    <div key={ans.question_id} style={{ marginBottom: 24 }}>
                      <div style={{ fontWeight: 600, fontSize: "1.08rem", marginBottom: 8 }}>
                        {isShareThoughts
                          ? ans.question
                          : `${String(questionIndexMap[ans.question_id]).padStart(2, "0")}. ${ans.question}`}
                      </div>
                      <div>
                        {isShareThoughts ? (
                          <textarea
                            value={ans.answer || ""}
                            readOnly
                            rows={4}
                            style={{
                              width: "100%",
                              maxWidth: 500,
                              background: "#f5f5f5",
                              color: "#222",
                              borderRadius: 8,
                              border: "1px solid #d1d5db",
                              padding: "12px",
                              fontSize: "1rem"
                            }}
                          />
                        ) : (
                          ["Strongly Agree", "Agree", "Neutral", "DisAgree", "Strongly DisAgree"].map(opt => (
                            <div key={opt} style={{ marginBottom: 6 }}>
                              <label
                                style={{
                                  color: ans.answer === opt ? answerColors[opt] : "#bdbdbd",
                                  fontWeight: ans.answer === opt ? 600 : 400,
                                  fontSize: "1rem"
                                }}
                              >
                                <input
                                  type="radio"
                                  checked={ans.answer === opt}
                                  readOnly
                                  style={{
                                    accentColor: ans.answer === opt ? answerColors[opt] : "#bdbdbd",
                                    marginRight: 8
                                  }}
                                />
                                {opt}
                              </label>
                            </div>
                          ))
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            ))
          )}
          <button
            className="quizzes-view-details-btn"
            style={{ marginTop: 18 }}
            onClick={() => navigate(-1)}
          >
            Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default ViewDetails;